import React, { useEffect, useState } from 'react';
import { Button, TextField, Box } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { getSupplierById, updateSupplier } from '../services/supplierService';
import { useTranslation } from 'react-i18next';

const EditSupplier = () => {
  const { t } = useTranslation();
  const [form, setForm] = useState({ Name: '', Email: '', Phone: '' });
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    fetchSupplier();
  }, []);

  const fetchSupplier = async () => {
    const data = await getSupplierById(id);
    setForm(data);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await updateSupplier(id, form);
    navigate('/suppliers');
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 400, mx: 'auto' }}>
      <TextField
        label={t("supplier_name")}
        name="Name"
        value={form.Name}
        onChange={handleChange}
        fullWidth
        required
        sx={{ mb: 2 }}
      />
      <TextField
        label={t("email_address")}
        name="Email"
        value={form.Email}
        onChange={handleChange}
        fullWidth
        sx={{ mb: 2 }}
      />
      <TextField
        label={t("phone_number")}
        name="Phone"
        value={form.Phone}
        onChange={handleChange}
        fullWidth
        sx={{ mb: 2 }}
      />
      <Button type="submit" variant="contained" color="primary">
        {t("update_supplier")}
      </Button>
    </Box>
  );
};

export default EditSupplier;